import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function formatBytes(bytes: number, decimals = 2) {
	if (bytes === 0) return '0 Bytes';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

/**
 * Format duration in seconds to a readable format (MM:SS or HH:MM:SS)
 */
export function formatDuration(seconds: number): string {
	if (seconds === 0) return '0:00';

	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = Math.floor(seconds % 60);

	// Format with leading zeros
	const formattedMinutes = minutes.toString();
	const formattedSeconds = remainingSeconds.toString().padStart(2, '0');

	// Include hours only if there are any
	if (hours > 0) {
		return `${hours}:${minutes.toString().padStart(2, '0')}:${formattedSeconds}`;
	}

	return `${formattedMinutes}:${formattedSeconds}`;
}
